import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({ standalone: false,
    selector: 'irb-security-components-dialog',
    templateUrl: './security-components-dialog.component.html',
    styleUrls: ['./security-components-dialog.component.scss']
})
export class SecurityComponentsDialogComponent implements OnInit {

    dTitle: string = 'Security components';
    gridHeight: string = "200px";
    rebalCompSecurityDTOList: any = [];
    gridOptions: any;
    accountNumber: string;
    private groupSecurity: string = '';

    constructor(public dialogRef: MatDialogRef<SecurityComponentsDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any) {

        if (mdd) {
            this.rebalCompSecurityDTOList = mdd.rebalCompSecurityDTOList || [];
            this.groupSecurity = mdd.groupSecurity || '';
            this.accountNumber = this.rebalCompSecurityDTOList.length !== 0 ? this.rebalCompSecurityDTOList[0].compSecAccountNumber : '';
            this.dTitle = this.groupSecurity + ' components'
        }

        let ht: number = this.rebalCompSecurityDTOList.length * 30 + 35;
        if (ht > 300) {
            ht = 300;
        }
        ht = ht < 70 ? 70 : ht;
        this.gridHeight = ht + 'px';

        this.gridOptions = {
            columnDefs: this.getColumnDefs(),
            floatingFilter: false
        };

    }

    ngOnInit(): void {
    }

    close() {
        this.dialogRef.close();
    }

    private getColumnDefs() {

        const columns: any = [
            {
                headerName: 'Symbol',
                field: 'compSecuritySymbol'
            },
            {
                headerName: 'Description',
                field: 'compSecurityDesc'
            }
        ];

        return columns;
    }

    onGridReady(params: any) {
        params.api.sizeColumnsToFit();
    }
}
